// var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

// Object.defineProperty(exports, "__esModule", {
//   value: true,
// });
// exports.default = void 0;

// var _react = _interopRequireDefault(require("react"));

// var _createSvgIcon = _interopRequireDefault(
//   require("@material-ui/icons/utils/createSvgIcon")
// );

// var _default = (0, _createSvgIcon.default)(
//   _react.default.createElement(
//     _react.default.Fragment,
//     null,
//     _react.default.createElement("path", {
//       d: "M19,5V19H5V5H19m0-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Z"
//     }),
//     _react.default.createElement("path", {
//       d: "M27,13a2.9948,2.9948,0,0,0-2.8157,2H18v2h6.1843A2.9947,2.9947,0,1,0,27,13Zm0,4a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,17Z"
//     }),
//     _react.default.createElement("path", {
//       d: "M12.3,16.18l-.57-1.87H8.86l-.57,1.87H6.5L9.27,8.29h2l2.78,7.89Zm-1-3.27c-.53-1.69-.82-2.65-.89-2.87s-.11-.4-.14-.53c-.12.46-.46,1.6-1,3.4Z"
//     }),
//     _react.default.createElement("path", {
//       d: "M14.88,8.62c0-.53.3-.8.89-.8s.89.27.89.8a.76.76,0,0,1-.22.59.9.9,0,0,1-.67.22C15.18,9.43,14.88,9.16,14.88,8.62Zm1.71,7.56H15v-6h1.64Z"
//     })
//   ),
//   "AiIcon"
// );

// exports.default = _default;


import * as React from "react";
const AiIcon = (props) => (
  <svg
    width="28px"
    height="30px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{"ai"}</title>
    <path d="M19,5V19H5V5H19m0-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Z" />
    <g>
      <path d="M12.3,16.18l-.57-1.87H8.86l-.57,1.87H6.5L9.27,8.29h2l2.78,7.89Zm-1-3.27c-.53-1.69-.82-2.65-.89-2.87s-.11-.4-.14-.53c-.12.46-.46,1.6-1,3.4Z" />
      <path d="M14.88,8.62c0-.53.3-.8.89-.8s.89.27.89.8a.76.76,0,0,1-.22.59.9.9,0,0,1-.67.22C15.18,9.43,14.88,9.16,14.88,8.62Zm1.71,7.56H15v-6h1.64Z" />
    </g>
    <rect width={24} height={24} fill="none" />
  </svg>
);
export default AiIcon;
